import { TransactionHistory } from '@components/shared';

import { AddPurchasePayment } from './add-payment.component';
import {
    PurchaseDetailsProvider,
    usePurchaseDetailsContext,
} from './purchase-details.context';
import { PurchaseHeader } from './purchase-header.component';
import { PurchaseItems } from './purchase-items.component';
import { SupplierInfo } from './supplier-info.component';

const PurchaseDetailsComponent = () => {
    const { data } = usePurchaseDetailsContext();
    return (
        <main
            className={
                'min-h-[calc(100vh_-_var(--header-height)_-_16px)] bg-background p-4'
            }
        >
            <div className="mx-auto">
                <PurchaseHeader />

                {/* Main Content Grid */}
                <div className="mt-3 grid gap-4 lg:grid-cols-3">
                    {/* Invoice Details - Left Side */}
                    <div className="lg:col-span-2">
                        <PurchaseItems />
                    </div>

                    {/* Supplier Info - Right Side */}
                    <div className="space-y-4">
                        <SupplierInfo />
                        {/* <PurchasePayment /> */}
                        <AddPurchasePayment />
                    </div>
                </div>

                {/* Transaction History */}
                <div className="mt-4">
                    <TransactionHistory
                        transactions={data?.data?.payment?.transactions}
                    />
                </div>
            </div>
        </main>
    );
};

export const PurchaseDetails = () => {
    return (
        <PurchaseDetailsProvider>
            <PurchaseDetailsComponent />
        </PurchaseDetailsProvider>
    );
};

PurchaseDetails.displayName = 'PurchaseDetails';
